//export const webUrl = process.env.NODE_ENV === 'development' ? '' : '';

export const BaseUrl = 'https://www.xirou.com';
export const isDevelopment = process.env.NODE_ENV === "development";

export const webUrl = isDevelopment
  ? "http://localhost:3000"
  : "https://www2.xirou.com";


export const apiUrl = isDevelopment
  ? "http://localhost:45666"
  // ? "http://192.168.101.5:45666"
  : "https://api2.xirou.com";
